var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.462,
    height: 37.798,
    viewBox: "0 0 40.462 37.798",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488",
    transform: "translate(-555.979 -92.267)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_472",
    "data-name": "Line 472",
    x2: 36.461,
    y2: 33.797,
    transform: "translate(557.979 94.268)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.831
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_473",
    "data-name": "Line 473",
    x1: 36.461,
    y2: 33.797,
    transform: "translate(557.979 94.268)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.831
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.82230d94b547ce93398dfe1b1a7ed931.svg";
export { ForwardRef as ReactComponent };